<p>adfs login processing - please wait ...</p>
